import type { AppState } from 'types/app';

export const selectLocation = (state: AppState) => state.router.location;

export const selectPathname = (state: AppState) => state.router.location.pathname;

export const selectQueryParams = (state: AppState) => state.router.location.search;
